// like https://www.npmjs.com/package/deep-diff, but not deep

import { keys, isEqual, without, difference } from 'lodash-es'

export default function topDiff(prev, curr) {
  const prevKeys = keys(prev)
  const currKeys = keys(curr)

  const appendedKeys = difference(currKeys, prevKeys)
  const removedKeys = difference(prevKeys, currKeys)
  const editedKeys = without(currKeys, ...appendedKeys).filter((key) => !isEqual(prev[key], curr[key]))

  const diff = []
  appendedKeys.forEach((aKey) => diff.push({ kind: 'N', path: [aKey], lhs: undefined, rhs: curr[aKey] }))
  removedKeys.forEach((rKey) => diff.push({ kind: 'D', path: [rKey], lhs: prev[rKey], rhs: curr[rKey] }))
  editedKeys.forEach((eKey) => diff.push({ kind: 'E', path: [eKey], lhs: prev[eKey], rhs: curr[eKey] }))
  return diff
}
